var v1="<div class=\"chart\"></div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("analysis/scatter-data/scatter-chart.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/analysis/scatter-data/scatter-chart.jade
// module id = 514
// module chunks = 0